<template>
    <div :class="{ 'active': active }" class="accordion-item">
        <div class="accordion-header d-flex align-items-center justify-content-between">
            <span>{{ title }}</span>
        </div>
        <div>
            <Transition :duration="350" name="nested">
                <div v-show="active" v-dompurify-html="body" class="accordion-body" />
            </Transition>
        </div>
    </div>
</template>
<script setup lang="ts">
defineProps<{ body: string; title: string; active: boolean }>();
</script>
<style lang="scss" scoped>
.accordion-item {
    width: 100%;
    padding: 1.5rem 2rem;
    border-radius: 0.375rem;
    border: 1px solid var(--main-grey-e-4-e-6-e-7, #e4e6e7);
    background: var(--main-white-ffffff, #fff);
}

.accordion-header {
    width: 100%;
    cursor: pointer;

    display: flex;

    span {
        color: #48538b;
        /* title/h3 */
        font-family: Roboto;
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.75rem; /* 140% */
    }
}

.accordion-header::after {
    content: url('/icon/arrow_down.svg');
    height: 1.4375rem;
    transition: transform 0.3s;
}

.active .accordion-header::after {
    rotate: 180deg;
}

.accordion-body {
    padding: 1.5rem 0 0 0 !important;
}

.nested-enter-active,
.nested-leave-active {
    transition: all 0.3s ease-in-out;
}

/* delay leave of parent element */
.nested-leave-active {
    transition-delay: 0.25s;
}

.nested-enter-from,
.nested-leave-to {
    transform: translateY(30px);
    opacity: 0;
}

/* we can also transition nested elements using nested selectors */
.nested-enter-active .accordion-body,
.nested-leave-active .accordion-body {
    transition: all 0.3s ease-in-out;
}

/* delay enter of nested element */
.nested-enter-active .accordion-body {
    transition-delay: 0.25s;
}

.nested-enter-from .accordion-body,
.nested-leave-to .accordion-body {
    transform: translateX(30px);
    opacity: 0.001;
}

.accordion-body ::v-deep(ul) {
    list-style-type: none;
    padding-left: 0;
    gap: 1rem;
    margin-bottom: unset;
    display: flex;
    flex-direction: column;
}
.accordion-body ::v-deep(ul li) {
    display: flex;
    background-image: url('@/assets/images/icons/gray-line.svg');
    background-repeat: no-repeat;
    line-height: 1.625rem;
    padding-left: calc(20px + 0.5rem);
}

.accordion-body ::v-deep(p:last-child) {
    margin-bottom: unset;
}
</style>
